import store from "../store";
import statusEnum from "../enums/modules/statusEnum";
import purchasePaymentStatusEnum from "../enums/modules/purchasePaymentStatusEnum";
import purchaseStatusEnum from "../enums/modules/purchaseStatusEnum";
import askEnum from "../enums/modules/askEnum";
import taxTypeEnum from "../enums/modules/taxTypeEnum";
import orderStatusEnum from "../enums/modules/orderStatusEnum";
import returnStatusEnum from "../enums/modules/returnStatusEnum";
import VueSimpleAlert from "vue3-simple-alert";
import currencyPositionEnum from "../enums/modules/currencyPositionEnum";

export default {
    phoneFormat: function (n) {
        let num = String(n).replace(/\D/g, '').slice(0, 10);
        if (num.length === 0) return '';
        let formated = num.replace(/(\d{3})(\d{3})(\d{0,4})/, function (_, p1, p2, p3) {
            return [p1, p2, p3].filter(Boolean).join(' ');
        });
        return formated;
    },

    phoneNumber: function (e) {
        let char = String.fromCharCode(e.keyCode);
        if (/^[+]?[0-9]*$/.test(char)) return true;
        else e.preventDefault();
    },

    onlyNumber: function (e) {
        let res = (e.charCode !== 8 && e.charCode === 0 || (e.charCode >= 48 && e.charCode <= 57));
        if (res)
            return true;
        else
            e.preventDefault();
    },

    floatNumber: function (e) {
        let char = String.fromCharCode(e.keyCode);
        if (/^[.]?[0-9]*$/.test(char)) return true;
        else e.preventDefault();
    },

    currencyFormat(amount, decimal, currency, position) {
        if (amount === null || amount === undefined || isNaN(amount)) {
            amount = 0;
        }

        const globalState = store.getters['globalState/lists'] || {};
        const setting = store.getters['frontendSetting/lists'] || {};

        let rate = 1;
        let activeSymbol = currency;
        let activePosition = position;

        if (globalState.currency_code) {
            rate = parseFloat(globalState.exchange_rate || 1);
            if (globalState.currency_symbol) {
                activeSymbol = globalState.currency_symbol;
            }
        }

        if (decimal === null || decimal === undefined) {
            decimal = setting.site_digit_after_decimal_point !== undefined ? Number(setting.site_digit_after_decimal_point) : 2;
        } else {
            decimal = Number(decimal);
        }

        const convertedAmount = parseFloat(amount) * rate;

        const thousandSeparator = setting.site_thousand_separator !== undefined && setting.site_thousand_separator !== null ? setting.site_thousand_separator : ',';
        const decimalSeparator = thousandSeparator === '.' ? ',' : '.';

        const parts = convertedAmount.toFixed(decimal).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
        const formattedNumber = parts.join(decimalSeparator);

        if (activePosition === currencyPositionEnum.LEFT) {
            return activeSymbol + formattedNumber;
        } else {
            return formattedNumber + activeSymbol;
        }
    },

    floatFormat(amount, decimal = 2) {
        return parseFloat(amount).toFixed(decimal);
    },

    sideDrawerShow: function (id = 'sideDrawer') {
        const drawerDivs = document?.querySelectorAll(".drawer");
        const drawerSets = document?.querySelectorAll("[data-drawer]");
        drawerSets?.forEach((drawerSet) => {
            const targetElm = document?.querySelector(drawerSet?.dataset?.drawer);
            drawerSets?.forEach(drawerBtn => drawerBtn?.classList?.remove("active"));
            drawerDivs?.forEach(drawerDiv => drawerDiv?.classList?.remove("active"));
            targetElm?.classList?.add("active");
            drawerSet?.classList?.add("active");
            document.body.style.overflowY = "hidden";
            document?.querySelector(".backdrop")?.classList?.add("active");
        });
    },
    sideDrawerHide: function (id = 'sideDrawer') {
        const drawerDivs = document?.querySelectorAll(".drawer");
        const drawerSets = document?.querySelectorAll("[data-drawer]");
        document?.querySelectorAll("#sidebar")?.forEach((closeBtn) => {
            drawerSets?.forEach(drawerBtn => drawerBtn?.classList?.remove("active"));
            drawerDivs?.forEach(drawerDiv => drawerDiv?.classList?.remove("active"));
            document?.querySelector(".backdrop")?.classList?.remove("active");
            document.body.style.overflowY = "auto"
        });
    },

    modalShow: function (id = '.modal') {
        const modalTarget = document?.querySelector(id);
        modalTarget?.classList?.add("active");
        document.body.style.overflowY = "hidden";
    },

    modalHide: function (id = ".modal") {
        let modalDivs = document?.querySelectorAll(id);
        document.body.style.overflowY = "auto";
        modalDivs?.forEach((modalDiv) => modalDiv?.classList?.remove("active"));
    },

    recursiveRouter: function (routes, permission) {
        const hasPermissions = Array.isArray(permission) && permission.length > 0;
        const permissionMap = {};
        if (hasPermissions) {
            for (let i = 0; i < permission.length; i++) {
                const perm = permission[i];
                if (perm && perm.url) {
                    permissionMap[perm.url] = perm;
                }
            }
        }

        const applyPermissions = (routeList) => {
            if (!Array.isArray(routeList)) return;

            for (let i = 0; i < routeList.length; i++) {
                const route = routeList[i];
                const meta = route?.meta;
                if (meta?.permissionUrl) {
                    if (hasPermissions && permissionMap[meta.permissionUrl]) {
                        const perm = permissionMap[meta.permissionUrl];
                        meta.access = perm.access;
                        meta.title = perm.title;
                    } else if (!hasPermissions) {
                        // Limpiar permiso remanente al cerrar sesión
                        delete meta.access;
                    }
                }

                if (route?.children) {
                    applyPermissions(route.children);
                }
            }
        };

        applyPermissions(routes);
    },

    textShortener: function (text, number = 30) {
        if (text) {
            if (!(text.length < number)) {
                return text.substring(0, number) + "..";
            }
        }
        return text;
    },
    htmlTagRemover: function (text) {
        if ((text != null && text !== '' && isNaN(text))) {
            return text.replace(/(<([^>]+)>)/ig, '');
        }
        return text;
    },
    statusClass: function (status) {
        if (status === statusEnum.ACTIVE) {
            return "db-table-badge border border-success text-xs text-success bg-green-100";
        } else {
            return "db-table-badge border border-danger text-xs text-danger bg-red-100";
        }
    },

    askClass: function (ask) {
        if (ask === askEnum.YES) {
            return "db-table-badge border border-success text-xs text-success bg-green-100";
        } else {
            return "db-table-badge border border-red-500 bg-red-100 text-red-500 text-xs";
        }
    },

    requestHandler: function (requests) {
        let i = 1;
        let what = "?";
        let response = "";

        for (let request in requests) {
            if (requests[request] !== "" && requests[request] !== null) {
                if (i !== 1) {
                    response += "&";
                }
                response += request + "=" + requests[request];
            }
            i++;
        }

        if (response) {
            response = what + response;
        }

        return response;
    },

    responsiveLoad: function () {
        let mainHeader = document?.querySelector(".db-header");
        let subHeader = document?.querySelector(".sub-header");
        let mainHeight = mainHeader?.scrollHeight;

        if (subHeader) {
            subHeader.style.top = `${mainHeight}px`;
        }
    },

    permissionChecker: function (permissionName) {
        let i, permissions = store.getters.authPermission;
        for (i = 0; i < permissions.length; i++) {
            if (typeof permissions[i].name !== "undefined" && permissions[i].name) {
                if (permissions[i].name === permissionName) {
                    return permissions[i].access;
                }
            }
        }
    },

    formDataShow: function (formData) {
        for (let pair of formData.entries()) {
            console.log(pair[0] + " : " + pair[1]);
        }
    },
    destroyConfirmation: function () {
        return new VueSimpleAlert.confirm(
            "No podrás recuperar el registro eliminado!",
            "Confirmación requerida",
            "advertencia",
            {
                confirmButtonText: "Sí, elimínalo",
                cancelButtonText: "No, cancelar",
                confirmButtonColor: "#696cff",
                cancelButtonColor: "#8592a3",
                customClass: {
                    container: "container-alert bg-light/50 backdrop-blur",
                    popup: "popup-alert shadow-lg !p-10 rounded-xl",
                    title: "font-client font-medium text-2xl text-primary",
                }
            }
        );
    },
    confirmation: function ({ title = "Confirmación requerida", text = "¿Estás seguro?", confirmButtonText = "Sí, continuar", cancelButtonText = "Cancelar", confirmButtonColor = "#696cff" } = {}) {
        return new VueSimpleAlert.confirm(
            text,
            title,
            "advertencia",
            {
                confirmButtonText: confirmButtonText,
                cancelButtonText: cancelButtonText,
                confirmButtonColor: confirmButtonColor,
                cancelButtonColor: "#8592a3",
                customClass: {
                    container: "container-alert bg-light/50 backdrop-blur",
                    popup: "popup-alert shadow-lg !p-10 rounded-xl",
                    title: "font-client font-medium text-2xl text-primary",
                }
            }
        );
    },

    taxTypeClass: function (type) {
        if (type === taxTypeEnum.FIXED) {
            return "db-table-badge border border-blue-500 text-blue-500 bg-blue-100 text-xs";
        } else {
            return "db-table-badge border border-warning text-orange-500 bg-orange-100 text-xs";
        }
    },
    underscoreToSpace: function (str) {
        return str.replace(/_/g, ' ');
    },
    decimalPoint: function (num, length = 2) {
        return Number.parseFloat(num).toFixed(length);
    },
    convertOnlyDateTime: function (value) {
        if (!value) {
            return "--";
        }

        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return value;
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    orderStatusClass: function (status) {
        if (status === orderStatusEnum.PENDING) {
            return "border border-amber-500 bg-amber-100 text-amber-500 text-xs";
        }
        else if (status === orderStatusEnum.CONFIRMED) {
            return "border border-indigo-500 bg-indigo-100 text-indigo-500 text-xs";
        }
        else if (status === orderStatusEnum.ON_THE_WAY) {
            return "border border-cyan-500 bg-cyan-100 text-cyan-500 text-xs";
        }
        else if (status === orderStatusEnum.DELIVERED) {
            return "border border-success bg-green-100 text-success text-xs";
        }
        else if (status === orderStatusEnum.CANCELED) {
            return "border border-red-500 bg-red-100 text-red-500 text-xs";
        }
        else {
            return "border border-red-500 bg-red-100 text-red-500 text-xs";
        }
    },

    purchasePaymentStatusClass: function (status) {
        if (status === purchasePaymentStatusEnum.PENDING) {
            return "border border-amber-500 bg-amber-100 text-amber-500 text-xs";
        }
        else if (status === purchasePaymentStatusEnum.PARTIAL_PAID) {
            return "border border-indigo-500 bg-indigo-100 text-indigo-500 text-xs";
        }
        else if (status === purchasePaymentStatusEnum.FULLY_PAID) {
            return "border border-success bg-green-100 text-success text-xs";
        }
    },
    purchaseStatusClass: function (status) {
        if (status === purchaseStatusEnum.PENDING) {
            return "border border-amber-500 bg-amber-100 text-amber-500 text-xs";
        }
        else if (status === purchaseStatusEnum.ORDERED) {
            return "border border-indigo-500 bg-indigo-100 text-indigo-500 text-xs";
        }
        else if (status === purchaseStatusEnum.RECEIVED) {
            return "border border-success bg-green-100 text-success text-xs";
        }
    },

    returnStatusClass: function (status) {
        if (status == returnStatusEnum.PENDING) {
            return "text-[#F6A609]";
        }
        else if (status == returnStatusEnum.ACCEPT) {
            return "text-[#2AC769]";
        }
        else {
            return "text-[#FB4E4E]";
        }
    },

    cancelOrder: function () {
        return new VueSimpleAlert.confirm(
            "¿Quieres cancelar el pedido?",
            "Confirmación requerida",
            "warning",
            {
                confirmButtonText: "Sí, cancélalo",
                cancelButtonText: "No, descartar",
                confirmButtonColor: "#696cff",
                cancelButtonColor: "#8592a3",
                customClass: {
                    container: "container-alert bg-light/50 backdrop-blur",
                    popup: "popup-alert shadow-lg !p-10 rounded-xl",
                    title: "font-client font-medium text-2xl text-primary",
                }
            }
        );
    },

    acceptOrder: function () {
        return new VueSimpleAlert.confirm(
            "¡No podrás cancelar el pedido!",
            "Confirmación requerida",
            "warning",
            {
                confirmButtonText: "Sí, aceptar",
                cancelButtonText: "No, cancelar",
                confirmButtonColor: "#696cff",
                cancelButtonColor: "#8592a3",
                customClass: {
                    container: "container-alert bg-light/50 backdrop-blur",
                    popup: "popup-alert shadow-lg !p-10 rounded-xl",
                    title: "font-client font-medium text-2xl text-primary",
                }
            }
        );
    },
    handleSlide: function (id) {
        const targetElement = document.querySelector(`#${id}`);

        if (!targetElement) {
            return;
        }

        targetElement.classList.add("transition-all", "duration-300", "ease-in-out");

        if (targetElement.style.visibility == 'visible') {
            targetElement.style.height = '0px';
            targetElement.style.overflow = 'hidden';
            targetElement.style.opacity = '0';
            targetElement.style.visibility = 'hidden';
        }
        else {
            targetElement.style.height = targetElement.scrollHeight + 'px'
            setTimeout(() => {
                targetElement.style.overflow = 'visible';
            }, 300);
            targetElement.style.opacity = '1';
            targetElement.style.visibility = 'visible';
        }
    },
    handleTab: function (event, targetID, targetButton, targetDiv, active) {
        const targetBtns = document.querySelectorAll(targetButton);
        const targetDivs = document.querySelectorAll(targetDiv);
        const currentBtn = event.currentTarget;
        const currentDiv = document.querySelector(targetID);
        targetBtns.forEach(item => item.classList.remove(active));
        targetDivs.forEach(item => item.classList.remove(active));
        currentBtn.classList.add(active);
        currentDiv.classList.add(active);
    },
    openSettingMenu: function (event) {
        const btn = event.currentTarget;
        const options = btn.nextElementSibling;
        const isExpanded = btn.getAttribute("aria-expanded") === "true";
        document.querySelectorAll(".settings-btn").forEach((otherBtn) => {
            if (otherBtn !== btn && otherBtn.getAttribute("aria-expanded") === "true") {
                const otherOptions = otherBtn.nextElementSibling;
                otherOptions.style.height = "0px";
                otherOptions.style.margin = "0px";
                otherBtn.querySelector(".icon").classList.remove("fa-chevron-up");
                otherBtn.querySelector(".icon").classList.add("fa-chevron-down");
                otherBtn.setAttribute("aria-expanded", "false");
            }
        });

        if (isExpanded) {
            options.style.height = "0px";
            options.style.margin = "0px";
            btn.querySelector(".icon").classList.remove("fa-chevron-up");
            btn.querySelector(".icon").classList.add("fa-chevron-down");
        } else {
            options.style.height = "auto";
            const pixel = options.scrollHeight;
            options.style.height = "0px";
            requestAnimationFrame(() => {
                options.style.height = `${pixel}px`;
                options.style.margin = "8px 0px 0px 0px";
            });

            btn.querySelector(".icon").classList.remove("fa-chevron-down");
            btn.querySelector(".icon").classList.add("fa-chevron-up");
        }

        btn.setAttribute("aria-expanded", !isExpanded);
    },

    closeSettingMenu: function (event) {
        if (!event.target.closest(".settings-btn")) {
            document.querySelectorAll(".settings-btn").forEach((btn) => {
                if (btn.getAttribute("aria-expanded") === "true") {
                    const options = btn.nextElementSibling;
                    options.style.height = "0px";
                    options.style.margin = "0px";
                    btn.querySelector(".icon").classList.remove("fa-chevron-up");
                    btn.querySelector(".icon").classList.add("fa-chevron-down");
                    btn.setAttribute("aria-expanded", "false");
                }
            });
        }
    },
    toggleSidebar: function () {
        const dbMain = document.querySelector('.db-main');
        const dbSidebar = document.querySelector('.db-sidebar');
        const backdrop = document.querySelector('.backdrop');
        if (dbMain) dbMain.classList.toggle('expand');
        if (dbSidebar) dbSidebar.classList.toggle('active');
        if (backdrop && window.innerWidth < 1024) backdrop.classList.toggle('active');
    },
    closeSidebar: function () {
        const dbMain = document.querySelector('.db-main');
        const dbSidebar = document.querySelector('.db-sidebar');
        const backdrop = document.querySelector('.backdrop');
        if (dbMain) dbMain.classList.remove('expand');
        if (dbSidebar) dbSidebar.classList.remove('active');
        if (backdrop) backdrop.classList.remove('active');
    }
};
